import {FetchParams, Middleware, RequestContext, ResponseContext} from "../../api-client-kt/src";
import {LoadingSpinner} from "../lib/loading-spinner";
import {Alerts} from "../lib/alerts";
import {ErrorContext} from "../../api-client-py/src";
import {RequestUtils} from "../lib/requests";

interface SilentRequestInit extends RequestInit {
    isSilent?: boolean;
}

export class LoadingSpinnerInterceptor implements Middleware {

    async pre(context: RequestContext): Promise<FetchParams | void> {
        this.fixTimezoneError(context);

        const hasIsSilentHeader = this.checkForSilentHeadersAndDiscard(context.init.headers);
        if (hasIsSilentHeader) {
            this.markAsSilent(context.init);
        } else {
            LoadingSpinner.lease();
        }

        return Promise.resolve({url: context.url, init: context.init});
    }

    async post(context: ResponseContext): Promise<Response | void> {
        const is2xxResponse = Math.floor(context.response.status / 100) === 2;
        const isSilent = this.isSilent(context.init);

        if (!isSilent) {
            LoadingSpinner.release();
        }

        if (!is2xxResponse) {
            const body = await context.response.text();
            if (!isSilent) Alerts.alertHttpErrorPopup({body: body});
            console.error(body);
        }

        return Promise.resolve();
    }

    onError(context: ErrorContext): Promise<Response | void> {
        const isSilent = this.isSilent(context.init);

        if (!isSilent) {
            LoadingSpinner.release();
            Alerts.alertHttpErrorPopup({body: context.error?.toString()});
        }

        console.error(context.error);
        return Promise.reject(context.error);
    }

    private checkForSilentHeadersAndDiscard(headers: HeadersInit | undefined): boolean {
        if (!headers) return false;
        const value = RequestUtils.getHeader(headers, 'X-API-Silent');
        if (value === 'true') {
            RequestUtils.deleteHeader(headers, 'X-API-Silent');
            return true;
        }
        return false;
    }

    private markAsSilent(init: RequestInit): void {
        (init as SilentRequestInit).isSilent = true;
    }

    private isSilent(init: RequestInit): boolean {
        return (init as SilentRequestInit).isSilent === true;
    }

    private fixTimezoneError(context: RequestContext) {
        if (/changes\?from.*Z/.test(context.url)) {
            // This is a workaround for a known issue with the API that fails with a 500 error
            // when the 'from' parameter contains a timezone offset (e.g. 'Z').
            // We remove the 'Z' to avoid this issue.
            // context.url = context.url.replace('Z', '');
        }
    }
}
